import React, { createContext, useContext, useRef, useState } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Form } from "react-bootstrap";

const FormContext = createContext(null);

export function useMultiStepForm(steps, handleSubmit, formDisabled = false, renderTopContent = null) {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [formDetails, setFormDetails] = useState({});
  const [formLoading, setFormLoading] = useState(false);
  const form = useRef();

  // console.log(formDetails, currentStepIndex)

  async function handleNext(e, form) {
    e.preventDefault();
    const newForm = Object.fromEntries(new FormData(form.current).entries());
    // if(newForm.teamName){
    //   const match = newForm.teamName === newForm.teamCode
    //   console.log(match)
    // }
    // console.log({ ...formDetails, ...newForm });

    if (newForm) {
      let next = nextFormStep();
      setFormDetails((prev) => {
        return { ...prev, ...newForm };
      });
      if (!next) {
        setFormLoading(true);
        const error = await handleSubmit({ ...formDetails, ...newForm });
        if (error) {
          setFormLoading(false);
        }
      }
    }
  }

  function nextFormStep() {
    if (currentStepIndex >= steps.length - 1) {
      return false;
    }
    setCurrentStepIndex((prev) => prev + 1);
    return true;
  }
  function prevFormStep() {
    if (currentStepIndex <= 0) {
      return false;
    }
    setCurrentStepIndex((prev) => prev - 1);
    return true;
  }
  function goToFormStep(stepIndex) {
    const nextStepIndex = Math.max(0, Math.min(stepIndex, steps.length - 1));
    setCurrentStepIndex(nextStepIndex);
  }
  const CurrentForm = () => {
    const topContent =
      typeof renderTopContent === "function"
        ? renderTopContent({ currentStepIndex, steps, formDetails, formLoading })
        : renderTopContent;

    return (
      <FormContext.Provider value={{ formLoading, formDetails }}>
        <Form className="grid h-full" ref={form} onSubmit={(e) => handleNext(e, form)}>
          <fieldset disabled={formDisabled}>
            {formLoading ? (
              <div
                className="flex flex-col h-full items-center justify-center text-center gap-1"
                role="status"
                aria-live="polite"
              >
                <div className="w-40 h-40" aria-hidden="true">
                  <DotLottieReact
                    src={`${process.env.PUBLIC_URL}/animations/walking-shoes.lottie`}
                    autoplay
                    loop
                  />
                </div>
                <h2>Personalizing your experience</h2>
              </div>
            ) : (
              <>
                {topContent}
                <div className="flex gap-4 justify-between items-center text-3xl p-3 py-2 font-medium">
                  <button
                    type="button"
                    onClick={() => prevFormStep()}
                    className={currentStepIndex <= 0 ? "opacity-50" : ""}
                    disabled={currentStepIndex <= 0 ? true : false}
                    tabIndex={-1}
                  >
                    {"←"}
                  </button>
                  {steps.map((e, i) => {
                    return (
                      <div
                        key={i}
                        className={
                          (currentStepIndex === i
                            ? "font-bold"
                            : "opacity-20") +
                          " mb-0 mt-1.5 cursor-default w-full h-1 rounded-md bg-slate-500"
                        }
                      ></div>
                    );
                  })}
                  <button tabIndex={-1} type="submit">
                    {"→"}
                  </button>
                </div>
                {steps[currentStepIndex]}
              </>
            )}
          </fieldset>
        </Form>
      </FormContext.Provider>
    );
  };
  return {
    formDetails,
    formLoading,
    currentStepIndex,
    step: steps[currentStepIndex],
    CurrentForm,
    nextFormStep,
    prevFormStep,
    goToFormStep,
    setFormDetails,
  };
}

export function useFormContext() {
  return useContext(FormContext);
}
